import { nanoid } from 'nanoid';

function generateUID() {
    return nanoid().replace(/^\d+/g, '').replace(/-/g, '_');
}

export { generateUID };
